import React, { useState } from "react";
import { useAuth } from "../App";
import { useNavigate } from "react-router-dom";

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

// In Login.js:
const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    console.log('🔵 Login attempt starting for username:', username);
  
    const response = await fetch("/.netlify/functions/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });
  
    const result = await response.json();
    console.log('🔵 API Response:', { ok: response.ok, result });
  
    if (response.ok) {
      const expiry = Date.now() + 24 * 60 * 60 * 1000;
      const userData = { 
        ...result,
        username,
        expiry,
      };
      console.log('🔵 Created userData object:', userData);
      
      login(userData);
      
      const storedToken = localStorage.getItem("authToken");
      const storedUser = localStorage.getItem("authUser");
      console.log('🔵 Stored data check:', { 
        tokenStored: !!storedToken, 
        userStored: !!storedUser,
        storedUserData: JSON.parse(storedUser)
      });
  
      if (!storedToken) {
        console.error("❌ Token was not stored properly!");
      }
  
      console.log('🔵 Navigating to home page');
      navigate("/");
    } else {
      console.error('❌ Login failed:', result.error);
      setError(result.error);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-neutral-900">
      <div className="bg-neutral-800 p-8 rounded-lg shadow-lg w-96">
        <h2 className="text-white text-center text-2xl mb-4">Login</h2>
        {error && <p className="text-red-500 text-center">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Username"
            className="w-full p-3 rounded bg-neutral-700 text-white"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            className="w-full p-3 rounded bg-neutral-700 text-white"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit" className="w-full bg-blue-600 p-3 rounded text-white hover:bg-blue-500">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
